import React, { useCallback } from 'react';
import styled from 'styled-components';
import { mainTheme, Radio } from '@plecto/ui';
import HelpInline from '../helpInline/HelpInline';

const S = {};
S.Container = styled.div`
	display: flex;
	align-items: center;
	&:not(:first-child) {
		margin-top: 0.5em;
	}
`;

S.RadioOption = styled.div`
	display: inline-block;
	cursor: pointer;
	margin-bottom: 0;
	
	${Radio.cssSelector} {
		cursor: pointer;
	}
`;

S.Label = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	color: ${mainTheme.text.secondary};
`;

S.Help = styled(HelpInline)`
	margin: 0 0 0 0.5em;
	min-height: 0;
	display: inline-flex;
	color: ${mainTheme.text.tertiary};
`;

export function RadiosFieldOptionControl({ label, optionSelected, option, onSelect, help }) {
	const onChangeCallback = useCallback(() => {
		onSelect(option);
	}, [onSelect, option]);

	return <S.Container>
		<S.RadioOption onClick={onChangeCallback}>
			<S.Label>
				<Radio checked={optionSelected} readOnly/>
				{label}
			</S.Label>
		</S.RadioOption>
		{help ? <S.Help text={help} /> : null}
	</S.Container>;
}

export default function RadiosFieldOption({ children }) {
	if (!React.isValidElement(children)) return null;
	return children;
}
